export const IS_DEV = process.env.NODE_ENV === 'development';

export const AIRPARK_SUPPORT_EMAIL = process.env.AIRPARK_SUPPORT_EMAIL ?? 'hello@airpark.app'

export const PermitQueueType = {
    AreaParking: 'AreaParking',
    AnyNumberedSpot: 'AnyNumberedSpot',
}